// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import IconEducator from '@/components/icons/educator.vue'
import IconCheck from '@/components/icons/check.vue'
import IconBase from '@/components/IconBase.vue'
import IconForwardBack from '@/components/icons/arrowForward.vue'
import Globals from '@/assets/scripts/global-functions.js'
import Axios from "axios"
import NextButton from '@/components/forms/ButtonNext.vue'
import DateOfBirth from '@/components/forms/DateOfBirth.vue'
import IconArrowRight from '@/components/icons/arrowForward.vue'
export default {
    name: 'GetStarted',
    components: {
        IconEducator,
        IconCheck,
        IconBase,
        IconForwardBack,
        NextButton,
        DateOfBirth,
        IconArrowRight
    },
    data () {
        return {
            dialog_check_sessions: false,
            db_birthdate: "",
            db_session: "",
            wrong_birthday: ""
        }    
    },
    methods: {
        Next() {
            this.$parent.Role = 'educator';
            this.$parent.GoToPage('Package');
        },
        disableModal(){
            this.dialog_check_sessions = false;
        },
        Continue(_params){
            if(_params == "No"){
                this.NotContinue();
            }else{
                this.YesContinue();
            }
        },
        NotContinue(){
            this.disableModal();
            Globals.CleanStorage("EducatorInsuranceProcess");
        },
        YesContinue(){
            let _dob = this.$refs.dob.GetDateOfBirth();
            const _session = "EducatorInsuranceProcess";
            const _islocal = true;
            if(_dob.valid) {
                var confirm_bdate = new Date(_dob.year,_dob.month - 1,_dob.day);

                var dbbirthdate = new Date(this.db_birthdate);

                if(confirm_bdate.getTime() === dbbirthdate.getTime()) {
                    this.$parent.EducatorInsuranceProcess = JSON.parse(localStorage.getItem(_session));
                    this.$parent.EducatorProcessCurrentStep = this.$parent.EducatorInsuranceProcess.current_step;
                    this.disableModal();
                    this.Next();
                    /* old code - DO NOT REMOVE | THIS CODE IS CONNECTED TO THE POS
                    this.$parent.EducatorInsuranceProcess = this.db_session.data;
                    this.$parent.is_local_storage = true;
                    this.$parent.session_id = this.db_session.id;
                    //this.$parent.SessionUpdate("EducatorInsuranceProcess");
                    Globals.SessionUpdate(_session, this.$parent.EducatorInsuranceProcess, _islocal, this.$parent.Role);
                    this.disableModal();
                    */
                } else {
                    //this.wrong_birthday = "Birthday does not match! Please try again."
                    this.$refs.dob.CustomErrorMessage("Birthday does not match! Please try again.");
                    this.dialog_check_sessions = true;
                }
            }
        },
        ValidateSessionData() {
            // set _islocal to false if you want to set this to session storage 
            const _session = "EducatorInsuranceProcess";
            const _islocal = true;
            const _prevdata = Globals.IsThereaProgress(_session, _islocal);
            if(_prevdata) {
                let _data = Globals.ValidateProgressEntry(_session, _islocal);
                if(_data.Educators) {
                    if((_data.Educators[0].email_address != "") || (_data.Educators[0].email_address != "")) {
                        if((_data.Educators[0].date_of_birth != "") || (_data.Educators[0].date_of_birth != null)) {
                            this.db_birthdate = _data.Educators[0].date_of_birth;
                            this.dialog_check_sessions = true;    
                            //this.GetSessionByEmail();
                        }
                    }
                }
            }
        },
        GetSessionByEmail() {
            let CheckSessionByEmail_ = Globals.CheckSessionByEmail("EducatorInsuranceProcess", this.$parent.EducatorInsuranceProcess, this.$parent.Role);
            CheckSessionByEmail_.then(response => {
                var count = response.data.customizations.results.length;
                this.db_session = response.data.customizations.results[0];
                
                //if session exist
                if(count > 0 ) {
                    //check session if not expired
                    let isSessionNotExpired = Globals.CheckSessionExpiry("EducatorInsuranceProcess", db_session.date_expiry, db_session.session_id);
                
                    if(isSessionNotExpired == "false") {
                        //session not yet expired
                        this.dialog_check_sessions = true;
                        this.db_birthdate = this.db_session.educators[0].date_of_birth;
                        let today = new Date(); 
                        let today_date = today.getDate() + today.getMonth() + ' ' + today.getFullYear();
                        this.$parent.EducatorInsuranceProcess.date_modified = today_date;
                        Globals.UpdateExpiryDate(this.db_session.id, this.$parent.Role);
                    }
                }
            })
            .catch(response => { 
                console.error("Check Session By Email", response);
            });
        }
    },
    mounted () {
        this.$parent.Role = "educator";
        this.ValidateSessionData();
        this.$parent.CheckWindowPathName();
    },
    watch : {

    },
}